"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollToTop = void 0;
var ScrollToTop_1 = require("./ScrollToTop");
Object.defineProperty(exports, "ScrollToTop", { enumerable: true, get: function () { return ScrollToTop_1.ScrollToTop; } });
//# sourceMappingURL=index.js.map